import { decode } from 'base64-arraybuffer';
import { supabase } from './supabase';
import { useUserStore } from '../store/userStore';
import type { ImageMediaType } from '../types';

// Photo de profil importée (bannière + avatar). Stockée dans le bucket public "avatars",
// rangée par utilisateur : {uid}/avatar et {uid}/banner (chemin stable → upsert, pas d'orphelins).

export type ProfileImageTarget = 'avatar' | 'banner';
export const AVATARS_BUCKET = 'avatars';

// Envoie la photo dans Storage puis renvoie son URL publique HORODATÉE : le chemin étant stable,
// le ?t= force l'<Image> à recharger la nouvelle photo malgré le cache.
export async function uploadProfileImage(
  target: ProfileImageTarget,
  base64: string,
  mediaType: ImageMediaType,
): Promise<string> {
  const userId = useUserStore.getState().user?.id;
  if (!userId) throw new Error('Tu dois être connecté.');

  const path = `${userId}/${target}`;
  const { error } = await supabase.storage
    .from(AVATARS_BUCKET)
    .upload(path, decode(base64), { contentType: mediaType, upsert: true });
  if (error) throw error;

  const { data } = supabase.storage.from(AVATARS_BUCKET).getPublicUrl(path);
  return `${data.publicUrl}?t=${Date.now()}`;
}
